import { motion } from "framer-motion";
import { QUOTES } from "@/data/news";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1], delay: i * 0.15 },
  }),
};

export const Quotes = () => (
  <section id="quotes" data-testid="quotes-section" className="border-t border-white/10 pt-16">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="mb-12"
    >
      <span className="font-mono-news text-xs text-[#4ADE80] uppercase tracking-widest">Testimonies</span>
      <h2 className="font-display text-5xl sm:text-6xl text-white tracking-tight leading-none mt-3">
        The Friends Left Behind
      </h2>
    </motion.div>

    <div className="grid md:grid-cols-2 gap-8">
      {QUOTES.map((q, i) => (
        <motion.blockquote
          key={q.id}
          data-testid={`quote-${q.id}`}
          custom={i}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="relative bg-[#121214] border border-white/10 p-8 sm:p-10 hover:border-[#4ADE80]/40 transition-colors duration-500"
        >
          <span aria-hidden="true" className="font-display text-8xl text-[#4ADE80]/25 absolute top-3 left-6 leading-none select-none">
            "
          </span>
          <p className="relative font-mono-news text-lg sm:text-xl text-zinc-200 leading-relaxed pt-10">
            {q.quote}
          </p>
          <footer className="mt-8 border-t border-white/10 pt-5">
            <div className="font-display text-2xl text-[#4ADE80] tracking-wide">{q.author}</div>
            <div className="font-mono-news text-[10px] sm:text-xs text-zinc-500 uppercase tracking-widest mt-1">{q.role}</div>
          </footer>
        </motion.blockquote>
      ))}
    </div>
  </section>
);
